import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "contents-title-text" };
const _hoisted_2 = { class: "table-wrapper" };
const _hoisted_3 = { class: "button-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_WorkerFeePerStoreGroupSettingGroupTable = _resolveComponent("WorkerFeePerStoreGroupSettingGroupTable");
    const _component_WorkerFeePerStoreGroupSettingAddGroupDialog = _resolveComponent("WorkerFeePerStoreGroupSettingAddGroupDialog");
    const _component_WorkerFeePerStoreGroupSettingEditGroupDialog = _resolveComponent("WorkerFeePerStoreGroupSettingEditGroupDialog");
    const _component_WorkerFeePerStoreGroupStoreSetting = _resolveComponent("WorkerFeePerStoreGroupStoreSetting");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_v_card_title, { class: "card-title d-flex align-center" }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t(`${_ctx.lc}sub_title_group_setting`)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }),
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_WorkerFeePerStoreGroupSettingGroupTable)
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" 추가 "),
            _createVNode(_component_WorkerFeePerStoreGroupSettingAddGroupDialog)
        ]),
        _createCommentVNode(" [다이얼로그] 수정 / 삭제 "),
        _createVNode(_component_WorkerFeePerStoreGroupSettingEditGroupDialog),
        _createCommentVNode(" [다이얼로그] 상점 설정 "),
        _createVNode(_component_WorkerFeePerStoreGroupStoreSetting)
    ]));
}
